import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import useAdditionalTimeElapsed from 'containers/EmployeeTimeClock/shared/useAdditionalTimeElapsed';

interface IProps {
  breakData: any;
}

const AdditionalBreakTimer: React.FC<IProps> = ({ breakData }) => {
  const additionalTime = useAdditionalTimeElapsed(breakData?.startLocal, breakData?.break_type?.length);

  return (
    <>
      <Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" textAlign="center" width="80%">
        {breakData?.break_type?.no_set_length ? (
          <>
            <Text fontWeight="semibold" fontSize="lg">
              Break in Progress!
            </Text>
            <Heading as="span" size="xl">
              {additionalTime}
            </Heading>
          </>
        ) : (
          <>
            <Text fontWeight="semibold" fontSize="lg">
              Your break is over!
            </Text>
            <Heading as="span" size="xl">
              {additionalTime}
            </Heading>
          </>
        )}
      </Box>
    </>
  );
};
export default AdditionalBreakTimer;
